import React from 'react';
import { CreditCard, Clock, PiggyBank, Handshake, Award } from 'lucide-react';
import { formatMoney } from '../../utils/format';
import { useTranslation } from '../../i18n';
import { getLoyaltyLabel } from '../../data/bankData';

export function BankSummaryTiles({ totalDebt, credits, monthlyCredit, totalPlacementValue, activePlacements, bank, loyaltyLevel, relation, scoreRevealed, creditScore }) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-3">
        <div className="flex items-center gap-2 text-slate-500 text-xs mb-1"><CreditCard className="w-3.5 h-3.5" /><span>{t('total_debt')}</span></div>
        <p className={`text-lg font-bold ${totalDebt > 0 ? 'text-danger' : 'text-slate-500'}`}>{formatMoney(totalDebt)}</p>
        <p className="text-[10px] text-slate-500">{credits.length} {t('active_loans')}</p>
      </div>
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-3">
        <div className="flex items-center gap-2 text-slate-500 text-xs mb-1"><Clock className="w-3.5 h-3.5" /><span>{t('monthly_payments')}</span></div>
        <p className="text-lg font-bold text-warn">{formatMoney(monthlyCredit)}</p>
        <p className="text-[10px] text-slate-500">{t('per_month')}</p>
      </div>
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-3">
        <div className="flex items-center gap-2 text-slate-500 text-xs mb-1"><PiggyBank className="w-3.5 h-3.5" /><span>{t('placements_label')}</span></div>
        <p className={`text-lg font-bold ${totalPlacementValue > 0 ? 'text-money' : 'text-slate-500'}`}>{formatMoney(totalPlacementValue)}</p>
        <p className="text-[10px] text-slate-500">{activePlacements.length} {t('placement_count')}</p>
      </div>
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-3">
        <div className="flex items-center gap-2 text-slate-500 text-xs mb-1"><Handshake className="w-3.5 h-3.5" /><span>{t('loyalty')}</span></div>
        <p className="text-sm font-bold" style={{ color: bank?.color }}>{getLoyaltyLabel(loyaltyLevel)}</p>
        <p className="text-[10px] text-slate-500">{relation.loansRepaid} {t('loans_repaid')}</p>
      </div>
      {scoreRevealed && creditScore && (
        <div className="bg-ink-800 rounded-lg border-2 p-3" style={{ borderColor: creditScore.color }}>
          <div className="flex items-center gap-2 text-slate-500 text-xs mb-1"><Award className="w-3.5 h-3.5" /><span>Score bancaire</span></div>
          <div className="flex items-center gap-2">
            <span className="text-2xl font-black" style={{ color: creditScore.color }}>{creditScore.grade}</span>
            <div>
              <p className="text-xs font-bold" style={{ color: creditScore.color }}>{creditScore.score}/100</p>
              <p className="text-[10px] text-slate-500">{creditScore.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
